// angular
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

// bootstrap
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

// font awesome
import {
  FontAwesomeModule,
  FaIconLibrary,
} from "@fortawesome/angular-fontawesome";
import {
  faSignOutAlt,
  faSignInAlt,
  faUser,
  faUsers,
  faCogs,
  faUsersCog,
  faEnvelope,
  faTrash,
  faEdit,
  faCheck,
  faTimes,
  faPen,
  faPlus,
  faExternalLinkAlt
} from "@fortawesome/free-solid-svg-icons";

// app modules
import { AppRoutingModule } from "./app-routing.module";
import { ConfigurationModule } from "./configuration/configuration.module";
import { ServiceBusModule } from "./service-bus/service-bus.module";

// app components
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import {
  MsalModule,
  MsalInterceptor,
  MsalAngularConfiguration,
  MSAL_CONFIG,
  MSAL_CONFIG_ANGULAR,
  MsalService,
} from "@azure/msal-angular";
import { Configuration } from "msal";
import { AppConfigService } from './core/app-config.service';
import { AppConfig } from './core/app-config';
import { LayoutModule } from '@progress/kendo-angular-layout';


let appConfig : AppConfig;

export function initApp(acs: AppConfigService) : Promise<any> {
  console.log('app initializer fn');
  return acs
    .load()
    .then(() => appConfig = acs.current);
}

export function getProtectedResourceMap() : [string, string[]][] | Map<string, Array<string>> {
  return [
    [
      `${appConfig.configApiUrl}`,
      [`${appConfig.configApiAppUri}/api.readwrite`],
    ],
    [
      `${appConfig.serviceBusApiUrl}`,
      [`${appConfig.configApiAppUri}/api.readwrite`],
    ],
    ["https://graph.microsoft.com/v1.0/me", ["user.read"]],
  ];
}

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

function MSALConfigFactory(): Configuration {
  let auth = {
    clientId: appConfig.adminPortalClientId,
    authority: appConfig.authorityUrl,
    validateAuthority: true,
    redirectUri: appConfig.adminPortalUrl,
    postLogoutRedirectUri: appConfig.adminPortalUrl,
    navigateToLoginRequestUrl: true
  };
  return {
    auth: auth,
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
  };
}

function MSALAngularConfigFactory(): MsalAngularConfiguration {
  return {
    popUp: !isIE,
    consentScopes: [
      "user.read",
      "openid",
      "profile",
      `${appConfig.configApiAppUri}/api.readwrite`,
    ],
    unprotectedResources: ["https://www.microsoft.com/en-us/", "assets/app-config.json"],
    protectedResourceMap: getProtectedResourceMap(),
    extraQueryParameters: {},
  };
}

@NgModule({
  declarations: [AppComponent, HomeComponent],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgbModule,
    MsalModule,
    ConfigurationModule,
    ServiceBusModule,
    FontAwesomeModule,
    LayoutModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (acs: AppConfigService) => () => initApp(acs),
      deps: [AppConfigService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_CONFIG,
      useFactory: MSALConfigFactory,
    },
    {
      provide: MSAL_CONFIG_ANGULAR,
      useFactory: MSALAngularConfigFactory,
    },
    MsalService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    console.log(faSignOutAlt.iconName);
    library.addIcons(
      faTrash,
      faEdit,
      faPen,
      faCheck,
      faTimes,
      faPlus,
      faUser,
      faSignOutAlt,
      faSignInAlt,
      faUsers,
      faCogs,
      faUsersCog,
      faEnvelope,
      faExternalLinkAlt
    );
  }
}
